import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { type PersonInfoCardProps } from "../model";
import { PersonInfoCardDesktop, PersonInfoCardMobile } from "./components";

export const PersonInfoCard = (props: PersonInfoCardProps) => {
  const { personId, isEditMode, setIsEditMode } = props;

  return (
    <ResponsiveBlockSwitcher
      mobile={<PersonInfoCardMobile />}
      desktop={
        <PersonInfoCardDesktop
          personId={personId}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
        />
      }
    />
  );
};
